import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';

import { Box, CircularProgress } from '@mui/material';

import { validatePersistedSession } from '@/services/auth/sessionValidation';

type SessionValidationGateProps = Readonly<{
  children: ReactNode;
}>;

const SessionValidationGate = ({ children }: SessionValidationGateProps) => {
  const [isValidated, setIsValidated] = useState(false);

  useEffect(() => {
    let isMounted = true;

    validatePersistedSession()
      .then(result => {
        if (isMounted && result !== 'expired') {
          setIsValidated(true);
        }
      })
      .catch(() => {
        // Keep the application blocked if validation unexpectedly fails.
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (!isValidated) {
    return (
      <Box
        aria-label="Validating session"
        sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <CircularProgress size={40} />
      </Box>
    );
  }

  return children;
};

export default SessionValidationGate;
